<template>
    <a-modal :visible="visible"
             title="条码列表"
             width="800px"
             :mask="true"
             @cancel="close"
             :bodyStyle="customStyle"
             class="modal-content"
             :maskClosable="false"
             :centered="true">
        <div slot="footer">
            <a-button @click="close" :disabled="loading">关闭</a-button>
        </div>
        <a-spin :spinning="loading">
            <go-edit-table :dataSource="uniBarcodeList"
                           ref="barcodeTable"
                           :edit="true"
                           :showCheck="false"
                           :columns="uniBarcodeColumns"
                           :height="348">
                <div slot="action" slot-scope="{record}">
                    <a-popconfirm title="确定删除该条记录?" @confirm="() => handleDelete(record.id)">
                        <a>删除</a>
                    </a-popconfirm>
                </div>
            </go-edit-table>
        </a-spin>
    </a-modal>
</template>

<script>
import {ModalMixin} from "@/utils/ModalMixin";
import {mixin} from "@/utils/mixin";
import {getAction, postAction} from "@/api/manage";
import GoEditTable from "@/components/tools/GoEditTable";

export default {
    name: "WmsShowBarcodeModal",
    components: {GoEditTable},
    mixins: [ModalMixin, mixin],
    data: function () {
        return {
            param: null,
            uniBarcodeList: [],
            uniBarcodeColumns: [{
                title: '货号',
                dataIndex: 'goodsNo',
                show: true,
                config: true,
                width: 100,
                canEdit: false,
                slotIgnore: true,
            },
                {
                    title: '货名',
                    dataIndex: 'goodsName',
                    show: true,
                    config: true,
                    width: 100,
                    canEdit: false,
                    slotIgnore: true,
                },
                {
                    title: '颜色',
                    dataIndex: 'colorName',
                    show: true,
                    config: true,
                    width: 100,
                    canEdit: false,
                    slotIgnore: true,
                },
                {
                    title: '尺码',
                    dataIndex: 'sizeName',
                    show: true,
                    config: true,
                    width: 100,
                    canEdit: false,
                    slotIgnore: true,
                },
                {
                    title: '条码',
                    dataIndex: 'barcode',
                    show: true,
                    config: true,
                    width: 150,
                    canEdit: false,
                    slotIgnore: true,
                },
                {
                    title: '数量',
                    dataIndex: 'quantity',
                    show: true,
                    config: true,
                    width: 80,
                    canEdit: false,
                    sum: true,
                    slotIgnore: true,
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    config: false,
                    scopedSlots: {
                        customRender: 'action',
                    },
                    width: 100,
                }],
            url: {
                warehouseOut: '/bill/warehouseOut/listUniBarcode',
                deleteWarehouseOut: '/bill/warehouseOut/deleteBarcode',
                warehouseIn: '/bill/warehouseIn/listUniBarcode',
                deleteWarehouseIn: '/bill/warehouseIn/deleteBarcode'
            }
        }
    },
    methods: {
        show: function (param) {
            this.visible = true
            this.param = param
            this.loadData()
        },
        loadData: function () {
            let postData = {
                wmsNo: this.param.wmsNo,
                goodsId: this.param.goodsId,
                colorId: this.param.colorId,
                specId: this.param.specId,
                sizeId: this.param.sizeId
            }
            this.loading = true
            let url = ""
            debugger
            if (this.param.type === 1) {
                url = this.url.warehouseOut
            } else if (this.param.type === 2) {
                url = this.url.warehouseIn
            }
            postAction(url, postData).then(res => {
                if (res.success) {
                    this.uniBarcodeList = this.formatTableData(res.result)
                }
            }).finally(() => {
                this.loading = false
            })
        },
        handleDelete: function (id) {
            this.loading = true
            let url = ""
            if (this.param.type === 1) {
                url = this.url.deleteWarehouseOut
            } else if (this.param.type === 2) {
                url = this.url.deleteWarehouseIn
            }
            getAction(url, {id}).then(res => {
                if (res.success) {
                    this.$message.success("删除成功")
                    this.loadData()
                }
            })
        }
    },
    computed: {
        customStyle: function () {
            let bodyStyle = {...this.modalStyle}
            bodyStyle.height = "400px";
            bodyStyle.padding = "4px"
            return bodyStyle
        },
    },
}
</script>

<style scoped>

</style>
